var map = {
	"./BuyProlon/AccordionItem": "FVmW",
	"./BuyProlon/AccordionItem.js": "FVmW",
	"./BuyProlon/AnnouncementBar": "OHFk",
	"./BuyProlon/AnnouncementBar.js": "OHFk",
	"./BuyProlon/BuyProlon": "1yO+",
	"./BuyProlon/BuyProlon.js": "1yO+",
	"./BuyProlon/FlavourAccord": "tOPY",
	"./BuyProlon/FlavourAccord.js": "tOPY",
	"./BuyProlon/FlavourCard": "1qnA",
	"./BuyProlon/FlavourCard.js": "1qnA",
	"./BuyProlon/ImageOnText": "7B0/",
	"./BuyProlon/ImageOnText.js": "7B0/",
	"./BuyProlon/QAccordion": "1pnG",
	"./BuyProlon/QAccordion.js": "1pnG",
	"./BuyProlon/TextCard": "yN7F",
	"./BuyProlon/TextCard.js": "yN7F",
	"./BuyProlon/TextCardList": "FyVb",
	"./BuyProlon/TextCardList.js": "FyVb",
	"./BuyProlon/TextOnly": "GP98",
	"./BuyProlon/TextOnly.js": "GP98",
	"./CardsSection/CardsWithImages": "dSJv",
	"./CardsSection/CardsWithImages.js": "dSJv",
	"./CardsSection/CardsWithText": "CACV",
	"./CardsSection/CardsWithText.js": "CACV",
	"./ContactUs/ContactUs": "/9bR",
	"./ContactUs/ContactUs.js": "/9bR",
	"./FAQ/FAQ": "lHur",
	"./FAQ/FAQ.js": "lHur",
	"./FeatureSection/Features": "CU00",
	"./FeatureSection/Features.js": "CU00",
	"./Footer/Footer": "txHC",
	"./Footer/Footer.js": "txHC",
	"./Footer/FooterWithInput": "6Ai6",
	"./Footer/FooterWithInput.js": "6Ai6",
	"./GetStarted/GetStarted": "IQuJ",
	"./GetStarted/GetStarted.js": "IQuJ",
	"./Header/main-header": "ZhbV",
	"./Header/main-header.js": "ZhbV",
	"./Hero/main-hero": "3wzJ",
	"./Hero/main-hero.js": "3wzJ",
	"./HomePage/BenifitSection/BenifitCard/BenifitCard": "zQzB",
	"./HomePage/BenifitSection/BenifitCard/BenifitCard.js": "zQzB",
	"./HomePage/BenifitSection/BenifitSection": "2mbf",
	"./HomePage/BenifitSection/BenifitSection.js": "2mbf",
	"./HomePage/BuySection/BuySection": "HEJj",
	"./HomePage/BuySection/BuySection.js": "HEJj",
	"./HomePage/CartSection/HelthyCommitment": "Z+8S",
	"./HomePage/CartSection/HelthyCommitment.js": "Z+8S",
	"./HomePage/CartSection/TestimonialCart": "0PuT",
	"./HomePage/CartSection/TestimonialCart.js": "0PuT",
	"./HomePage/CartSection/TestimonialDetail": "fF2t",
	"./HomePage/CartSection/TestimonialDetail.js": "fF2t",
	"./HomePage/CartSection/TrendingNow": "fsDP",
	"./HomePage/CartSection/TrendingNow.js": "fsDP",
	"./HomePage/CartSection/TrendingProduct": "PSIi",
	"./HomePage/CartSection/TrendingProduct.js": "PSIi",
	"./HomePage/DietSection/DietCard/DietCard": "jw0e",
	"./HomePage/DietSection/DietCard/DietCard.js": "jw0e",
	"./HomePage/DietSection/DietSection": "Cj8C",
	"./HomePage/DietSection/DietSection.js": "Cj8C",
	"./HomePage/DietSection/FastingMimicking": "IUGK",
	"./HomePage/DietSection/FastingMimicking.js": "IUGK",
	"./HomePage/PromoGrid/Hero": "Lz5N",
	"./HomePage/PromoGrid/Hero-Left": "VAo2",
	"./HomePage/PromoGrid/Hero-Left.js": "VAo2",
	"./HomePage/PromoGrid/Hero.js": "Lz5N",
	"./HomePage/PromoGrid/PromoGrid": "BqXz",
	"./HomePage/PromoGrid/PromoGrid.js": "BqXz",
	"./HomePage/PromoGrid/ScrollImage": "Qzmw",
	"./HomePage/PromoGrid/ScrollImage.js": "Qzmw",
	"./HomePage/Testimonials/TestimonialCard": "TbiP",
	"./HomePage/Testimonials/TestimonialCard.js": "TbiP",
	"./HomePage/Testimonials/Testimonials": "gXrK",
	"./HomePage/Testimonials/Testimonials.js": "gXrK",
	"./HomePage/TextSection/TextSection": "1Y2a",
	"./HomePage/TextSection/TextSection.js": "1Y2a",
	"./HomePage/WorkSection/WorkSection": "6QDZ",
	"./HomePage/WorkSection/WorkSection.js": "6QDZ",
	"./ImageSection/ImageWithText": "eRma",
	"./ImageSection/ImageWithText.js": "eRma",
	"./ImageSection/TextWithImage": "JHkz",
	"./ImageSection/TextWithImage.js": "JHkz",
	"./ImageSection/TwoColumnMultipleImages": "aR2M",
	"./ImageSection/TwoColumnMultipleImages.js": "aR2M",
	"./TextSections/TextBanner": "ERZP",
	"./TextSections/TextBanner.js": "ERZP",
	"./TextSections/TextTwoColumn": "Kgif",
	"./TextSections/TextTwoColumn.js": "Kgif",
	"./custom-sections-product/CardSection/BuyCard": "quZ1",
	"./custom-sections-product/CardSection/BuyCard.js": "quZ1",
	"./custom-sections-product/CardSection/BuyCardsList": "W7EP",
	"./custom-sections-product/CardSection/BuyCardsList.js": "W7EP",
	"./custom-sections-product/ImageSection/OnlyImage": "MlBU",
	"./custom-sections-product/ImageSection/OnlyImage.js": "MlBU",
	"./custom-sections-product/PlanSection/PlanCard": "/K0P",
	"./custom-sections-product/PlanSection/PlanCard.js": "/K0P",
	"./custom-sections-product/PlanSection/PlanSection": "uGaq",
	"./custom-sections-product/PlanSection/PlanSection.js": "uGaq",
	"./custom-sections-product/TextSection/HeroBanner": "8xfN",
	"./custom-sections-product/TextSection/HeroBanner.js": "8xfN",
	"./custom-sections-product/TextSection/TextBanner": "7LOm",
	"./custom-sections-product/TextSection/TextBanner.js": "7LOm"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = "eJQX";
module.exports = webpackContext;